var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.9603 64.54C48.3521 64.54 61.6403 51.2518 61.6403 34.86C61.6403 18.4682 48.3521 5.17999 31.9603 5.17999C15.5685 5.17999 2.28027 18.4682 2.28027 34.86C2.28027 51.2518 15.5685 64.54 31.9603 64.54Z",
    fill: "url(#paint0_radial_13_1118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint1_linear_13_1118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2802 18.25H18.3802V31.41H14.2802V18.25ZM16.3302 11.71C17.6402 11.71 18.7002 12.77 18.7002 14.08C18.7002 15.39 17.6402 16.45 16.3302 16.45C15.0202 16.45 13.9502 15.39 13.9502 14.08C13.9602 12.77 15.0202 11.71 16.3302 11.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9504 18.25H24.8704V20.05H24.9204C25.4704 19.01 26.8004 17.92 28.7904 17.92C32.9304 17.92 33.7004 20.64 33.7004 24.19V31.41H29.6104V25.01C29.6104 23.48 29.5804 21.52 27.4804 21.52C25.3504 21.52 25.0304 23.18 25.0304 24.9V31.41H20.9404V18.25H20.9504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13_1118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9612 34.8559) scale(29.6844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2482,
    stopColor: "#4C4C89",
    stopOpacity: 0.7518
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "#9898BB",
    stopOpacity: 0.4807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#D0D0E0",
    stopOpacity: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#F2F2F6",
    stopOpacity: 0.0897
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1118",
    x1: 7.0299,
    y1: 7.0299,
    x2: 40.9731,
    y2: 40.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.65,
    height: 64.54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame-1.dfe3dc26c34bbb3f461e99b134592205.svg";
export { ForwardRef as ReactComponent };